import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanActivateChild } from '@angular/router';
import { Observable } from 'rxjs';

import { AuthorizationService } from '../services/authorization.service';

@Injectable()
export class AuthorizationByKeyGuard implements CanActivate, CanActivateChild {
  constructor(private router: Router, private authorizationService: AuthorizationService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const type = route.data['type'];
    const resourceId = route.data['resourceId'];
    const operation = route.data['operation'];

    return new Observable<boolean>((subscriber) => {
      this.authorizationService.isAuthorizedByKey(type, resourceId, operation).subscribe((isAuthorized: boolean) => {
        if (!isAuthorized) {
          this.router.navigate(['/']);
          subscriber.next(false);
          subscriber.complete();
          return false;
        } else {
          subscriber.next(true);
          subscriber.complete();
          return true;
        }
      });
    });
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.canActivate(route, state);
  }
}
